__turbopack_context__.v({
  "content_row_link_popover": "l7CSna_content_row_link_popover",
});
